import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiGetZeusOrganizationsRequest,
  DefaultApiGetOrganizationCreateRequestsRequest,
  DefaultApiGetOnboardingRequestsRequest,
  DefaultApiGetOnboardingRequestByIdRequest,
  DefaultApiDeleteOnboardingRequestRequest,
  DefaultApiRegisterOrganizationRequest,
  DefaultApiRegisterNoteRequest,
  DefaultApiSendBackOnboardingRequestRequest,
  DefaultApiPutZeusGiveRewardPointsRequest,
  DefaultApiPostFaceToFaceKycIdentityDocumentRequest,
  DefaultApiGetOnboardingRequestPersonalInfoRequest,
  DefaultApiUpdateCorporateDocumentResultRequest,
  DefaultApiUploadCorporateDocumentRequest,
  DefaultApiPostFaceToFaceKycRequestRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const getZeusOrganizations = async (
  instance: AxiosInstance,
  params: DefaultApiGetZeusOrganizationsRequest
) => {
  return await userApiDefaultApiFactory(instance).getZeusOrganizations(params)
}

export const getOrganizationCreateRequests = async (
  instance: AxiosInstance,
  params: DefaultApiGetOrganizationCreateRequestsRequest
) => {
  return await userApiDefaultApiFactory(instance).getOrganizationCreateRequests(
    params
  )
}

export const getOnboardingRequests = async (
  instance: AxiosInstance,
  params: DefaultApiGetOnboardingRequestsRequest
) => {
  return await userApiDefaultApiFactory(instance).getOnboardingRequests(params)
}

export const getOnboardingRequestById = async (
  instance: AxiosInstance,
  params: DefaultApiGetOnboardingRequestByIdRequest
) => {
  return await userApiDefaultApiFactory(instance).getOnboardingRequestById(
    params
  )
}

export const sendBackOnboardingRequest = async (
  instance: AxiosInstance,
  params: DefaultApiSendBackOnboardingRequestRequest
) => {
  return await userApiDefaultApiFactory(instance).sendBackOnboardingRequest(
    params
  )
}

export const deleteOnboardingRequest = async (
  instance: AxiosInstance,
  params: DefaultApiDeleteOnboardingRequestRequest
) => {
  return await userApiDefaultApiFactory(instance).deleteOnboardingRequest(
    params
  )
}

export const registerOrganization = async (
  instance: AxiosInstance,
  params: DefaultApiRegisterOrganizationRequest
) => {
  return await userApiDefaultApiFactory(instance).registerOrganization(params)
}
export const registerNote = async (
  instance: AxiosInstance,
  params: DefaultApiRegisterNoteRequest
) => {
  return await userApiDefaultApiFactory(instance).registerNote(params)
}

export const putZeusGiveRewardPoints = async (
  instance: AxiosInstance,
  params: DefaultApiPutZeusGiveRewardPointsRequest
) => {
  return await userApiDefaultApiFactory(instance).putZeusGiveRewardPoints(
    params
  )
}

export const postFaceToFaceKycIdentityDocument = async (
  instance: AxiosInstance,
  params: DefaultApiPostFaceToFaceKycIdentityDocumentRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).postFaceToFaceKycIdentityDocument(params)
}

export const getOnboardingRequestPersonalInfo = async (
  instance: AxiosInstance,
  params: DefaultApiGetOnboardingRequestPersonalInfoRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).getOnboardingRequestPersonalInfo(params)
}

export const getKycReaderUsers = async (instance: AxiosInstance) => {
  return await userApiDefaultApiFactory(instance).getKycReaderUsers()
}

export const updateCorporateDocumentResult = async (
  instance: AxiosInstance,
  params: DefaultApiUpdateCorporateDocumentResultRequest
) => {
  return await userApiDefaultApiFactory(instance).updateCorporateDocumentResult(
    params
  )
}

export const uploadCorporateDocument = async (
  instance: AxiosInstance,
  params: DefaultApiUploadCorporateDocumentRequest
) => {
  return await userApiDefaultApiFactory(instance).uploadCorporateDocument(
    params
  )
}

export const postFaceToFaceKycRequest = async (
  instance: AxiosInstance,
  params: DefaultApiPostFaceToFaceKycRequestRequest
) => {
  return await userApiDefaultApiFactory(instance).postFaceToFaceKycRequest(
    params
  )
}

// Do Not Remove this line ===@import api client===
